<template>
  <div class="d-inline-flex mr-3 mb-3">
    <div class="p-2 mr-3 bg-success-200 rounded" :class="{'bg-info-200': color == 'blue', 'bg-danger-300': color == 'red', 'bg-warning-600': color == 'orange'}">
      <peity :type="'bar'" :options="{'fill': ['#fff'], 'width': 32, 'height': 32 }" :data="chart.toString()"></peity>
    </div>
    <div class="pt-0">
      <label class="fs-sm mb-0">{{ title }}</label>
      <h4 class="font-weight-bold mb-0">{{ text }} {{ prefix }}</h4>
    </div>
  </div>
</template>

<script>
  import Peity from 'vue-peity'

  export default {
    props: ['color', 'title', 'text', 'prefix'],
    components: {
      Peity,
    },
    data() {
      return {
        chart: [
          this.random(),
          this.random(),
          this.random(),
          this.random(),
          this.random()
        ]
      }
    },
    methods: {
      random() {
        return Math.floor(Math.random() * (10 - 1 + 1)) + 1
      }
    }
  }
</script>